const checkServices = async () => {
  // eslint-disable-next-line no-restricted-syntax
  const GOOGLE_SERVICE = `https://${import.meta.env.VITE_FIREBASE_AUTH_DOMAIN}/__connectivity_probe__?t=${Date.now()}`;
  // eslint-disable-next-line no-restricted-syntax
  const IGNITE_SERVICE = `${import.meta.env.VITE_IGNITE_TRANSPORT_URL}/__connectivity_probe__?t=${Date.now()}`;
  // eslint-disable-next-line no-restricted-syntax
  const BLAZE_SERVICE = `${import.meta.env.VITE_BLAZE_TRANSPORT_URL}/__connectivity_probe__?t=${Date.now()}`;
  // eslint-disable-next-line no-restricted-syntax
  const KLEOS_SERVICE = `${import.meta.env.VITE_KLEOS_TRANSPORT_URL}/__connectivity_probe__?t=${Date.now()}`;
  const services = [
    GOOGLE_SERVICE,
    IGNITE_SERVICE,
    BLAZE_SERVICE,
    KLEOS_SERVICE,
  ];

  const results = await Promise.all(
    services.map(async (service) => {
      try {
        await fetch(service, {
          mode: 'no-cors',
          credentials: 'omit', // no cookies/auth sent
          cache: 'no-store', // force fresh request, no cache
        });
        return true;
      } catch {
        return false; // DNS/firewall network error
      }
    }),
  );

  return results.every(Boolean);
};

export const checkFirewallConnectionLoader = async () => {
  const isServiceAllowed = await checkServices();
  if (!isServiceAllowed) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw new Response('Potential Firewall', { status: 497 });
  }
};
